<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="140px">
            <el-form-item :label="$t('integration.name')" prop="name">
                <el-input v-model.trim="dioForm.name" style="width: 250px;"
                    :placeholder="$t('integration.please_enter_a_name')" />
            </el-form-item>

            <el-form-item :label="$t('integration.code')" prop="code" :rules="defaultDisabled ? {} : rules['code']">
                <el-input v-model="dioForm.code" type="text" style="width:120px;margin-right:10px"
                    :disabled="defaultDisabled"> </el-input>
                <el-select v-model="codeUnit" :placeholder="$t('public.please')" style="width:120px"
                    @change="changeDefalutFn">
                    <el-option :label="$t('integration.system_automatic')" :value="0"></el-option>
                    <el-option :label="$t('integration.custom')" :value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('integration.subunits')" prop="level" v-if="childrenBool">
                <el-checkbox v-model="dioForm.level" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item>

        </el-form>

        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { sceneAddScene, sceneGetGeneSceneCode } from '@/api/modules/architecture.js';
import bus from '@/utils/bus.js';

export default {
    props: ['isShow', 'title', 'valueIndex'],
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow;
            },
            set: function (val) {
                if (!val) {
                    this.codeUnit = 0;
                    this.defaultDisabled = true;
                }
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        rules() {
            let codeFn = (rules, value, cb) => {
                let reg = /^[a-zA-Z0-9_-]{0,50}$/;
                if (!reg.test(value)) {
                    cb('编码格式只允许大小写字母、数字、-、_');
                }
                cb();
            };
            return {
                name: [
                    { required: true, message: $t('integration.name_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 30,
                        message: $t('integration.name_length_is_within_30'),
                        trigger: 'blur'
                    }
                ],
                // 区分是否可填校验
                code: [
                    { required: true, message: $t('integration.code_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 50,
                        message: $t('integration.code_length_is_within_50'),
                        trigger: 'blur'
                    },
                    {
                        validator: codeFn,
                        trigger: 'blur'
                    }
                ]
            };
        }
    },
    data() {
        return {
            codeUnit: 0,
            dioForm: {
                name: '',
                code: '',
                level: 1,
                parentCode: ''
            },
            // 默认系统  禁止
            defaultDisabled: true,
            // 子单元的控制
            childrenBool: false,
            // 点击的树对象
            treeObj: {}
        };
    },
    mounted() {
        this.hasFn();
        this.getSysCode();
        this.childrenBoolFn();
    },
    methods: {
        hasFn() {
            // 客户节点情况下的默认值
            if (this.$store.state.type !== 3 && this.$store.state.type !== 2) {
                // 处理默认赋值
                this.treeObj = this.$store.getters.SchemaTree[0];
            } else {
                // 处理不用账号的默认赋值
                this.treeObj = this.$store.getters.SchemaTree.slice(1)[0];
            }
        },
        childrenBoolFn() {
            bus.$on('nodeClickTree', row => {
                this.treeObj = { ...row };
                if (row.level === 0) {
                    this.childrenBool = false;
                } else {
                    this.childrenBool = true;
                }

                // 树节点功能类型，0-单元节点，1-平面图节点，2-地图节点
                // 如果选择的是单元节点且不为客户节点
                if (row.level !== 0 && row.funcType === 0) {
                    this.childrenBool = true;
                }
                // 如果选择的是平面图节点且不为客户节点
                else if (row.level !== 0 && row.funcType === 1) {
                    this.childrenBool = false;
                }
                // 如果选择的地图图节点且不为客户节点
                else if (row.level !== 0 && row.funcType === 2) {
                    this.childrenBool = true;
                }else if (row.level !== 0 && row.funcType === 3) {
                  this.childrenBool = true;
                }
            });
        },
        getSysCode() {
            sceneGetGeneSceneCode().then(({ result }) => {
                this.dioForm.code = result;
            });
        },
        changeDefalutFn(id) {
            this.defaultDisabled = !this.defaultDisabled;
            this.dioForm.code = '';
            if (id === 0) {
                this.getSysCode();
            }
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            const flag = await this.justify();
            if (!flag) return;
            const query = {};
            // 根节点（客户节点）只有 scopeId / scopeCode，子节点才有 sceneId / sceneCode
            // 注意：响应拦截器 humpObjectDeep 会把后端下划线转成驼峰，这里用驼峰取值
            const isScopeRoot = !this.treeObj['sceneId'];
            this.dioForm.parentCode = isScopeRoot
                ? (this.treeObj.scopeCode || 'scope')
                : (this.dioForm.level !== 1 ? this.treeObj.parentCode : this.treeObj.sceneCode);
            query.scene = { ...this.dioForm };
            query.type = this.valueIndex;
            // nodeId 规则：
            //   - 子节点下添加子节点：nodeId = sceneId（scene 表 id，后端用它查父节点）
            //   - 根节点（scope）下添加子节点：nodeId = scopeId（level=0 节点的 scopeId 就是 scene 表 id）
            //   - 未选中节点：nodeId = '0-0'（顶级创建）
            // 注意：SceneClx extends Scene，level=0 节点的 scopeId = clx.getId()，即 scene 表 id
            // 发送前 toSnakeCaseDeep 会把驼峰转下划线（nodeId → node_id）匹配后端 Jackson SNAKE_CASE
            const sceneId = this.treeObj['sceneId'];
            const scopeId = this.treeObj['scopeId'];
            query.nodeId = (sceneId !== undefined && sceneId !== null && sceneId !== '')
                ? String(sceneId)
                : (scopeId !== undefined && scopeId !== null && scopeId !== ''
                    ? String(scopeId)
                    : '0-0');
            // [测试] 打印选中节点和组装的 nodeId，验证数据获取
            console.log('[AddDialog] treeObj =', this.treeObj);
            console.log('[AddDialog] sceneId =', this.treeObj['sceneId'], ', scopeId =', this.treeObj['scopeId']);
            console.log('[AddDialog] 组装的 nodeId =', query.nodeId);
            // if (this.treeObj.funcType === 1) {
            //     query.scene.level = 0;
            // }
            // 地图节点的平面图
            // if (this.treeObj.funcType === 2) {
            //   query.scene.level = 1;
                // if (query.type === 1) {
                //     query.scene.level = 1;
                // }
                // // 地图节点的地图
                // else {
                //     query.scene.level = 0;
                // }
            // }
            // 后端 Jackson 使用自定义 FieldNamingStrategy，没有 @FieldNaming 注解的字段期望驼峰
            // 直接发送驼峰字段名（nodeId, parentCode 等），无需转换
            // [测试] 打印发送的完整请求数据
            console.log('[AddDialog] 发送给后端的数据 =', JSON.stringify(query, null, 2));
            sceneAddScene(query).then(({ result, state }) => {
                if (state.code === 200 && result !== -1 && result !== -2 && result !== -3 && result !== -500) {
                    this.$message.success(this.$t('public.tip_add_succ'));
                    this.isShowDialog = false;
                    bus.$emit('addSuccess');
                } else if (result === -1) {
                    this.$message.error($t('integration.name_already_exists'));
                } else if (result === -2) {
                    this.$message.error($t('integration.code_already_exists'));
                } else if (result === -3) {
                    this.$message.error($t('integration.the_added_node_type_is_incorrect'));
                } else if (result === -500) {
                    this.$message.error($t('integration.failed_to_add'));
                } else {
                    this.$message.error(state.msg);
                }
            });
        }
    }
};
</script>

<style></style>
